import { __decorate, __metadata } from "tslib";
import { MEDIA_PROPS_ACCESSOR, MEDIA_PROPS_EDITORDEF, MediaAssets } from '@common/media/shared';
import { UseRestraints } from '@core/shared/restraints';
import { CrudEndpoints, EditorDefinition, Expose, IdItemModel, ItemModelDefinition, ItemModelProp, Model, ModelId, Transform, Trim, ValidateNested } from '@core/shared/model';
import { CertificateRestraints } from './certificate.restraints';
export const CertificateRenderingInstructionNames = ['name', 'date'];
let CertificateRenderingInstruction = /*#__PURE__*/(() => {
  let CertificateRenderingInstruction = class CertificateRenderingInstruction extends Model {};
  __decorate([Expose(), __metadata("design:type", Object)], CertificateRenderingInstruction.prototype, "id", void 0);
  __decorate([Expose(), __metadata("design:type", Object)], CertificateRenderingInstruction.prototype, "position", void 0);
  CertificateRenderingInstruction = __decorate([ModelId("CertificateRenderingInstruction") // auto-generated by generate-model-ids
  ], CertificateRenderingInstruction);
  return CertificateRenderingInstruction;
})();
export { CertificateRenderingInstruction };
export function completeExistingCertificateRenderingInstructions(existing) {
  // existing may be unexpected value due to @Transform decorator
  const completed = Array.isArray(existing) ? [...existing] : [];
  CertificateRenderingInstructionNames.forEach(name => {
    if (!completed.find(instruction => {
      return instruction.id === name;
    })) {
      // not found, add default instruction.
      // TODO: Note that ModelFactory.fromData cannot be used here anymore because within decorator there's no way to create it anymore.
      // falling back to raw objects.
      // completed.push(ModelFactory.fromData(CertificateRenderingInstruction,{id:name}))
      completed.push({
        id: name
      });
    }
  });
  return completed;
}
let CertificateItem = /*#__PURE__*/(() => {
  let CertificateItem = class CertificateItem extends IdItemModel {
    toString() {
      return "Certificate " + this.name;
    }
  };
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: ''
  }), Trim(), __metadata("design:type", String)], CertificateItem.prototype, "name", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: true
  }), __metadata("design:type", Boolean)], CertificateItem.prototype, "enabled", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: []
  })
  // Note: for some reason, adding type transform info will lead to buggy result
  // @Structure(Array, () => CertificateRenderingInstruction)
  , Transform(({
    value
  }) => completeExistingCertificateRenderingInstructions(value), {
    toClassOnly: true
  }), ValidateNested(), __metadata("design:type", Array)], CertificateItem.prototype, "renderingInstructions", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: undefined
  }), __metadata("design:type", Number)], CertificateItem.prototype, "courseId", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: undefined
  }), __metadata("design:type", Object)], CertificateItem.prototype, "course", void 0);
  CertificateItem = __decorate([EditorDefinition('admin-certificate', {
    document: true,
    renderingInstructions: true,
    [MEDIA_PROPS_ACCESSOR]: MEDIA_PROPS_EDITORDEF
  }), CrudEndpoints({
    adminSingle: '/admin/courses/:id/certificate'
  }), UseRestraints(CertificateRestraints), ItemModelDefinition({
    texts: {
      item: 'Zertifikat',
      items: 'Zertifikate'
    }
  }), MediaAssets(['document']), ModelId("CertificateItem") // auto-generated by generate-model-ids
  ], CertificateItem);
  return CertificateItem;
})();
export { CertificateItem };